import { CdnDashboardTab, Translation } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getCdnDashboardTabs = (): TabItem[] =>
  [
    {
      key: CdnDashboardTab.TRAFFIC,
      name: i18n.t(`${Translation.Configuration}:tabs.dashboard.traffic`),
    },
    {
      key: CdnDashboardTab.LOG,
      name: i18n.t(`${Translation.Configuration}:tabs.dashboard.log`),
    },
    // {
    //   key: CdnDashboardTab.ATTACK_LOG,
    //   name: i18n.t(`${Translation.Configuration}:tabs.dashboard.attackLog`),
    // },
    {
      key: CdnDashboardTab.ERROR_LOG,
      name: i18n.t(`${Translation.Configuration}:tabs.dashboard.errorLog`),
    },
    {
      key: CdnDashboardTab.WAF_LOG,
      name: i18n.t(`${Translation.Configuration}:tabs.dashboard.wafLog`),
    },
  ] as const;
